import type { App } from 'vue';
import { vSafeHtml } from '../utils/sanitize-html';

export const SafeHtmlPlugin = {
    install(app: App) {
        app.directive('safe-html', vSafeHtml);
    },
};
